import upperFirst from 'lodash.upperfirst';
import camelCase from 'lodash.camelcase';
import baseConfig from './config/base-config'

function addBaseConfig(config) {
  config.schema.properties = {
    ...config.schema.properties,
    ...baseConfig.schema.properties
  }
  config.data = {
    ...config.data,
    ...baseConfig.data
  }
  return config
}

function getComponent() {
  const componentConfig = [];
  const requireConfig = require.context(
    './components',
    // 是否查询其子目录
    true,
    /package.json$/
  );
  requireConfig.keys().forEach(fileName => {
    const config = requireConfig(fileName);
    componentConfig.push(addBaseConfig(config));
  });

  return componentConfig;
}

function getPageConfig() {
  let pageConfig = {};
  const requireConfig = require.context(
    './',
    // 是否查询其子目录
    false,
    /package.json$/
  );
  requireConfig.keys().forEach(fileName => {
    const config = requireConfig(fileName);
    pageConfig = config;
  });

  return pageConfig;
}

function registerComponent(Vue) {
  const requireComponent = require.context(
    './components',
    // 是否查询其子目录
    true,
    /\.vue$/
  );

  requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
      camelCase(
        fileName
          .split('/')[1]
          .replace(/\.\w+$/, '')
      )
    );
    // 注册组件
    Vue.component(
      componentName,
      componentConfig.default || componentConfig
    );
  });
}

export default function init (Vue) {
  registerComponent(Vue);
  return {
    componentConfig: getComponent(),
    pageConfig: getPageConfig()
  };
};
